import React from "react";

const StatusTrueIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="13.462" height="10.674" viewBox="0 0 13.462 10.674" style={{margin:3}}>
  <path id="Path_2147" data-name="Path 2147" d="M-6316.687,3790.9l2.952,3.656,2.7-2.649,4.328-4.242" transform="translate(6317.465 -3786.948)" fill="none" stroke="#a9c133" strokeWidth="2"/>
</svg>
);
export default StatusTrueIcon;
